import $api from "../http";
export default class ServerService {
    static async get_tournaments(id=null){
        console.log(id)
        return $api.post("/get_tournaments",{id});
    }
    static async get_texts(page){
        return $api.get("/get_texts_site_user?page="+page)
    }
    static async get_footer_text(id){
        return $api.get("/get_text_footer?id="+id)
    }
}